import { TmWizardStep } from '@treasury/presentation/components/tm-wizard';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('tm-bo-positive-pay-filter-rules-permissions')
export class PositivePayFilterRulePermissions extends TmWizardStep {
    public stepLabel = 'ACH Exception filter rules';

    @property({ type: Number })
    public companyId?: number;

    @property({ type: Number })
    public userId?: number;

    public render() {
        return html`<div>Positive Pay Filter Rule Permissions</div>`;
    }

    public validate() {
        return true;
    }
}
